import TaxReportUseCase from "@domains/useCases/Reports/Tax/TaxReport";
import ClearTaxUseCase from "@domains/useCases/Reports/Tax/ClearTax";
export default (repositories) => {
    return {
        taxReport: {
            tax: new TaxReportUseCase(repositories.tax),
            clearTax: new ClearTaxUseCase(repositories.tax),
        },
    };
};
